import ReportIndex from '@/views/Report/Index.vue';

import DeliveryIncomeByMonth from '@/views/Report/Management/DeliveryIncome/DeliveryIncomeByMonth.vue';
import DeliveryIncomeByDay from '@/views/Report/Management/DeliveryIncome/DeliveryIncomeByDay.vue';
import DeliveryIncomeByHub from '@/views/Report/Management/DeliveryIncome/DeliveryIncomeByHub.vue';
import DeliveryIncomeByArea from '@/views/Report/Management/DeliveryIncome/DeliveryIncomeByArea.vue';
import DeliveryIncomeByProductType from '@/views/Report/Management/DeliveryIncome/DeliveryIncomeByProductType.vue';

import DeliveryTime from '@/views/Report/Management/DeliveryDuration/DeliveryTime.vue';
import DeliveryTimeByHub from '@/views/Report/Management/DeliveryDuration/DeliveryTimeByHub.vue';
import DeliveryTimeByArea from '@/views/Report/Management/DeliveryDuration/DeliveryTimeByArea.vue';

function getComponentFile(name: string) {
  if (name === 'DeliveryIncomeIndex') return ReportIndex;
  if (name === 'DeliveryTimeIndex') return ReportIndex;

  if (name === 'DeliveryIncomeByMonth') return DeliveryIncomeByMonth;
  if (name === 'DeliveryIncomeByDay') return DeliveryIncomeByDay;
  if (name === 'DeliveryIncomeByHub') return DeliveryIncomeByHub;
  if (name === 'DeliveryIncomeByArea') return DeliveryIncomeByArea;
  if (name === 'DeliveryIncomeByProductType') return DeliveryIncomeByProductType;

  if (name === 'DeliveryTime') return DeliveryTime;
  if (name === 'DeliveryTimeByHub') return DeliveryTimeByHub;
  if (name === 'DeliveryTimeByArea') return DeliveryTimeByArea;

  return null;
}

export const deliveryIncomeList = [
  {
    path: 'month',
    name: 'DeliveryIncomeByMonth',
    display: 'รายได้ค่าขนส่ง (เปรียบเทียบรายเดือน)',
  },
  {
    path: 'day',
    name: 'DeliveryIncomeByDay',
    display: 'รายได้ค่าขนส่ง (เปรียบเทียบรายวัน)',
  },
  {
    path: 'hub',
    name: 'DeliveryIncomeByHub',
    display: 'สรุปค่าขนส่งตามสาขา',
  },
  {
    path: 'area',
    name: 'DeliveryIncomeByArea',
    display: 'รายได้ตามเขตจัดส่ง',
  },
  {
    path: 'product-type',
    name: 'DeliveryIncomeByProductType',
    display: 'รายได้ตามประเภทสินค้า',
  },
];

export const deliveryDurationList = [
  {
    path: 'time',
    name: 'DeliveryTime',
    display: 'ระยะเวลาจัดส่ง',
  },
  {
    path: 'hub',
    name: 'DeliveryTimeByHub',
    display: 'ระยะเวลาจัดส่งตามสาขา',
  },
  {
    path: 'area',
    name: 'DeliveryTimeByArea',
    display: 'ระยะเวลาจัดส่งตามเขต',
  },
];

export const moduleList = [
  {
    path: 'delivery-income',
    name: 'DeliveryIncomeIndex',
    display: 'รายได้ค่าขนส่ง (Revenue)',
    children: deliveryIncomeList.map((module: any) => ({
      path: module.path,
      name: module.name,
      display: module.display,
      component: getComponentFile(module.name),
    })),
  },
  {
    path: 'delivery-time',
    name: 'DeliveryTimeIndex',
    display: 'ระยะเวลาจัดส่ง (Duration)',
    children: deliveryDurationList.map((module: any) => ({
      path: module.path,
      name: module.name,
      display: module.display,
      component: getComponentFile(module.name),
    })),
  },
];

export default moduleList.map((module: any) => ({
  path: module.path,
  name: module.name,
  component: getComponentFile(module.name),
  children: module.children,
}));
